import { Translations } from '../config/translations';
import { View } from './view';

export class StripeAchView extends View {

    renderForm() {
        this.renderPaymentButton();
        this.renderErrorContainer();
    }

    renderPaymentButton() {
        const form = document.createElement('div');
        form.setAttribute('id', 'stripe-ach-form');
        form.classList.add('df-f', 'df-f-stripe-ach');

        form.innerHTML = `${this.getPaymentButtonElement()}`;

        const formFragment = document.createDocumentFragment();
        formFragment.appendChild(form);

        const formContainer = this.getHtmlElement('#stripe-ach-form-block');
        formContainer.appendChild(formFragment);
    }

    renderErrorContainer() {
        const errorContainer = document.createElement('div');
        errorContainer.setAttribute('id', 'stripe_ach_error_container');
        errorContainer.setAttribute('class', 'hs-form stacked');
        errorContainer.innerHTML = `<label id='stripe_ach_error' class='hs-form stacked error df-f-label'></label>`;

        const widgetFooterContainer = this.getHtmlElement('#df-widget-footer');
        const widgetContainer = widgetFooterContainer.parentNode;
        if (widgetContainer) {
            widgetContainer.insertBefore(errorContainer, widgetFooterContainer.previousElementSibling);
        }
    }

    getPaymentButtonElement() {
        return `<fieldset class='form-columns-1 df-payment-field df-fieldset'>
                    <input type='button'
                        id='stripe_ach_button'
                        class='stripe-ach hs-button primary large df-input'
                        data-label="pay_now"
                        value='${Translations.PAY_NOW}'
                    />
                </fieldset>`;
    }

    setVisible(isActive: boolean) {
        const formContainer = this.getHtmlElement('#stripe-ach-form-block');
        const errorContainer = this.getHtmlElement('#stripe_ach_error_container');
        if (!formContainer || !errorContainer) {
            return;
        }
        if (isActive) {
            this.show(formContainer);
            this.show(errorContainer);
        } else {
            this.hide(formContainer);
            this.hide(errorContainer);
        }
    }

    showError(errorMessage: string) {
        const errorContainer = this.getHtmlElement('#stripe_ach_error_container');
        if (errorContainer) {
            this.getHtmlElement('#stripe_ach_error').innerText = errorMessage;
            this.show(errorContainer);
        }
    }

    setErrorMessageText(errorMessage: string) {
        const errorMessageContainer = this.getHtmlElement('#stripe_ach_error');
        if (errorMessageContainer) {
            errorMessageContainer.innerText = errorMessage;
        }
    }

}
